import { createConfirmation } from 'react-confirm'
import Student from 'mediators/Student';
import DockProvider from "./DockProvider";

const modal = createConfirmation(DockProvider);

// if only is given, the dock will load studentData from backend
export default function (opts = {}) {

  if (opts.student && opts.student instanceof Student !== true) {
    // we used {...opts.classDetail } because it has to be a new object
    return modal({
      ...opts,
      studentData: new Student(opts.student),
    });
  }

  return modal(opts);
}



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/index.js